import React, { useState, useEffect } from 'react';
// import CountUp from 'react-countup';
import MarginBottom from './MarginBottom';
import { useSelector } from 'react-redux';
import { ethers } from 'ethers';

const GYTN = ({ setShowModal }) => {
  // const [lastScrollY, setLastScrollY] = useState (0);
  const [poolPrize, setPoolPrize] = useState(0);
  const [drawnTime, setDrawnTime] = useState(0);
  const [roundNumber, setRoundNumber] = useState(0);
  const { connect, lotteryContract, tuesdayContract } = useSelector(
    state => state.provider
  );
  const { both, tuesday, friday, tuesdayTime, fridayTime } = useSelector(state => state.lotteryDay);
  

  useEffect(
    () => {
      if (connect) {
        getPollInfo();
      }
    },
    [connect]
  );

  const getPollInfo = async () => {
    if (both) {
      if (parseInt(tuesdayTime) < parseInt(fridayTime)) {
        getTuesdayLotteryInfo();
      } else {
        getFridayLotteryInfo();
      }
    } else {
      if (tuesday) {
        getTuesdayLotteryInfo();
      } else {
        getFridayLotteryInfo();
      }
    }

  };
  const getFridayLotteryInfo = async () => {
    const prize = await lotteryContract.functions.getBalance();
    const round = await lotteryContract.functions.roundNumber();
    const time = await lotteryContract.functions.lotteryEndTime();

    setPoolPrize(parseFloat(ethers.utils.formatEther(prize.toString())).toFixed(3));
    setRoundNumber(round.toString());
    setDrawnTime(new Date(time.toString() * 1000).toLocaleString());
  };

  const getTuesdayLotteryInfo = async () => {
    const prize = await tuesdayContract.functions.getBalance();
    const round = await tuesdayContract.functions.roundNumber();
    const time = await lotteryContract.functions.lotteryEndTime();

    setPoolPrize(parseFloat(ethers.utils.formatEther(prize.toString())).toFixed(3));
    setRoundNumber(round.toString());
    setDrawnTime(new Date(time.toString() * 1000).toLocaleString());
  };

  return (
    <div>

      <div className="flex justify-center items-center">
        <div className="w-11/12 h-[0.2px] border-t border-lyellow" />
      </div>

      <div className="w-full  flex flex-col justify-between">
        <div className="flex justify-evenly flex-col md:flex-row mt-8">
          <div className="space-y-4 text-white">
            <h1 className="text-[1.5em] sm:text-[2em] md:text-[3em] text-center">
              Get Your <span className="text-lyellow">Tickets</span> Now!
            </h1>
            {both
              ? <>
                {(parseInt(tuesdayTime) < parseInt(fridayTime)) ?
                  <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-5xl">
                    Tuesday Lottery{' '}
                  </h1>
                  :
                  <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-5xl">
                    Friday Lottery
                  </h1>
                }
              </>
              : tuesday
                ? <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-5xl">
                  Tuesday Lottery{' '}
                </h1>
                : <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-5xl">
                  Friday Lottery
                </h1>}

            <h2 className="text-center text-3xl sm:text-3xl md:text-4xl text-lyellow">
              <p>$ {poolPrize}</p>
            </h2>
            <h2 className="text-center text-2xl sm:text-3xl md:text-4xl text-lyellow">
              In Prizes
            </h2>
            <div className="flex flex-col items-center justify-between px-[5em] pb-5 pt-2">
              <div className="">
                <div className="block px-6 py-4 bg-black/50 rounded-t-2xl border border-black/20 shadow-md cursor-pointer w-[24em] sm:w-[30em]  md:w-[45em]">
                  <div className="flex justify-between items-center">
                    <p className="text-lyellow text-sm md:text-xl font-semibold">
                      Next Draw
                    </p>
                    <p className="text-lyellow text-sm sm:text-md">
                      #{roundNumber} | Draw: {drawnTime}
                    </p>
                  </div>
                </div>
                <div className="block p-6 bg-[#2a3137] border border-black/20 shadow-md cursor-pointer w-[24em] sm:w-[30em] md:w-[45em]">
                  <div className="flex flex-col justify-center space-y-5">
                    <div className="flex justify-start items-center">
                      <p className="text-lyellow text-xl font-semibold">
                        Prize Pool
                      </p>
                      <div className="pl-20 text-2xl">
                        {/* {lastScrollY > (document.body.clientHeight - (document.body.clientHeight * 0.98)) ?(<CountUp separator="," prefix="$" suffix=" " end={poolPrize} />):(<CountUp separator="," prefix="$" suffix=" " end={poolPrize} />)} */}
                        {/* <p className="text-sm text-white/70">576 in Token</p> */}
                        <p>$ {poolPrize}</p>

                      </div>
                    </div>
                    <div className="flex justify-start items-center">
                      <p className="text-lyellow text-xl font-semibold">
                        Your Tickets
                      </p>
                      <button
                        className="ml-14 bg-lyellow text-sm font-semibold py-2 px-4 hover:bg-[#1d2226] text-black hover:text-white transition ease-in duration-200 rounded-lg"
                        onClick={() => {
                          setShowModal(true);
                        }}
                      >
                        Buy Ticket
                      </button>
                    </div>
                  </div>
                </div>

                <div className="block p-6 bg-black/40 rounded-b-2xl border border-black/20 shadow-md mb-10 cursor-pointer w-[24em] sm:w-[30em] md:w-[45em]">
                  <div className="flex flex-col justify-center space-y-5">
                    <p className="text-sm text-white">
                      Match the winning number in the same order to share prizes. Current prizes up for grabs:
                    </p>
                    <div className="grid grid-cols-2 md:grid-cols-4">
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          2 Numbers
                        </p>
                        <p className="text-lg font-semibold">
                          $ {(parseFloat(poolPrize) * 0.02).toFixed(3)}
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          3 Numbers
                        </p>
                        <p className="text-lg font-semibold">
                          $ {(parseFloat(poolPrize) * 0.03).toFixed(3)}
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          4 Numbers
                        </p>
                        <p className="text-lg font-semibold">
                          $ {(parseFloat(poolPrize) * 0.05).toFixed(3)}
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          5 Numbers
                        </p>
                        <p className="text-lg font-semibold">
                          $ {(parseFloat(poolPrize) * 0.1).toFixed(3)}

                        </p>
                       
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          5 Numbers + 1 Starts
                        </p>
                        <p className="text-lg font-semibold">
                          $ {(parseFloat(poolPrize) * 0.2).toFixed(3)}

                        </p>
                
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          5 Numbers + 2 Starts
                        </p>
                        <p className="text-lg font-semibold">
                          $ {(parseFloat(poolPrize) * 0.4).toFixed(3)}

                        </p>
                     
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-red-500 text-sm font-semibold">
                          For Maintenance & Stake Holders
                        </p>
                        <p className="text-lg font-semibold">
                          $ {(parseFloat(poolPrize) * 0.2).toFixed(3)}

                        </p>
             
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <MarginBottom />
    </div>
  );
};

export default GYTN;
